var map = {
	"./api.js": "A96V",
	"./request.js": "BD6w"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "rVD/";


//////////////////
// WEBPACK FOOTER
// ./src/util/request \.js$
// module id = rVD/
// module chunks = 125